module.exports = __webpack_public_path__ + "static/blog6-051491022309e8f2c8ae22febb033b5c.png";